
import {ref} from "vue";
import {router} from "@inertiajs/vue3";
import {trans} from "laravel-vue-i18n";

const identitiesCache = ref({})
export function useUpkeep() {
    const identify = async (model = window.location.href.split('/').slice(-1)) => {
        model = cleanModel(model)
        console.log(identitiesCache.value)
        console.log(model)
        if(identitiesCache.value[model])
            return identitiesCache.value[model]
        const result = (await router.get(`app/${model}/identify`)).data
        identitiesCache.value[model] = result;
        return result
    }

    const list = async (model = window.location.href.split('/').slice(-1)) => {
        model = cleanModel(model)
        return (await router.get(`app/${model}`)).data
    }

    const deleteRecord = async (id, model = window.location.href.split('/').slice(-1)) => {
        model = cleanModel(model)
        const r = (await router.delete(`app/${model}/${id}`, model)).response.data;
        if(!r.success) {
            notify.error(trans('common.error'), r.message);
        } else {
            notify.success(trans('common.deletion'), r.message);
        }
        return r;
    }

    const read = async (id, model = window.location.href.split('/').slice(-2)) => {
        model = cleanModel(model)
        return (await router.get(`app/${model}/${id}`)).data
    }

    const update = async (id, model, data) => {
        model = cleanModel(model)
        return (await router.patch(`app/${model}/${id}`, {data: data})).data
    }

    const create = async (model, data) => {
        model = cleanModel(model)
        return (await router.post(`app/${model}`, {data: data})).data
    }

    const binding = async (model, target, binding, identifier) => {
        return (await router.get(`app/binding/${btoa(model)}/${btoa(target)}/${binding}/${identifier}`)).data
    }

    const attach = async (parentModel, parentId, childModel, childBinding, childId, modelThrough) => {
        return (await router.post(`app/binding/${btoa(parentModel)}/${parentId}/${btoa(childModel)}/${childBinding}/${childId}`, {
            modelThrough: modelThrough
        })).data
    }

    const cleanModel = (model) => {
        if(!model.includes('\\'))
            return model
        if(model)
            return (model.split('\\').slice(-1)[0]).replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()

        return model;
    }

    return {
        identify, list, deleteRecord, read, update, create, binding, attach
    }
}
